<template>
	<div ref="" style="border:0px solid red;">
		<div class="InfoTABPan">
			<div class="InfoTAB2_A" style="margin-left:20px;">{{getLangText("企业")}}</div>
			<div class="InfoTAB2" style="margin-left:10px;" @click="onAcctInfoClick">{{getLangText("账号")}}</div>
			<div class="InfoTAB2" style="margin-left:10px;" v-if="custAiFlag" @click="onAIInfoClick">{{getLangText("AI接口")}}</div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; margin-top:10px; float:left;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:350px;  margin-top:-1px; margin-left:20px;">{{getLangText('客户名称')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="custName">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:350px;  margin-top:-1px; margin-left:20px;">{{getLangText('客户邮箱')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="custEmail">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:350px;  margin-top:-1px; margin-left:20px;">{{getLangText('客户定位')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="custLocate">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:350px;  margin-top:-1px; margin-left:20px;">{{getLangText('设备开放公共资源')}}</div>
			<radio ref="idSourceFlag1" style="height:30px; margin-right:20px;" v-model="chkSourceFlag" :size="18" :root="{obj:this}" :grpName="'GrpSourceFlag'" :val="1" :capt="getLangText('可见')"></radio>
			<radio ref="idSourceFlag0" style="height:30px; margin-right:20px;" v-model="chkSourceFlag" :size="18" :root="{obj:this}" :grpName="'GrpSourceFlag'" :val="0" :capt="getLangText('不可见')"></radio>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:350px;  margin-top:-1px; margin-left:20px;">{{getLangText('设备开放公共模板')}}</div>
			<radio ref="idModelFlag1" style="height:30px; margin-right:20px;" v-model="chkModelFlag" :size="18" :root="{obj:this}" :grpName="'GrpModelFlag'" :val="1" :capt="getLangText('可见')"></radio>
			<radio ref="idModelFlag0" style="height:30px; margin-right:20px;" v-model="chkModelFlag" :size="18" :root="{obj:this}" :grpName="'GrpModelFlag'" :val="0" :capt="getLangText('不可见')"></radio>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:250px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:350px;  margin-top:-1px; margin-left:20px;">{{getLangText('设备用Logo')}}</div>

			<input type="file" ref="idImgFile" style="display:none;" accept=".jpg,.png" @change="onImgChange"/>
			<div style="float:left; width:300px; height:200px; margin-top:10px; border:1px solid #bbbbbb; display:flex; flex-direction:column; align-items:center; cursor:pointer;" @click="onFileClick">
				<img ref="idImgPan" style="flex:0 0 auto; width:300px; height:200px; float:left; border:0px solid red;">

				<div style="float:left; width:100%; height:12px; margin-top:200px;">
					<div style="float:left; width:297px; height:12px; border-radius:5px; border:1px solid #2a83cf; margin-top:6px; display:none; position:relative;">
						<div style="position:absolute; width:0%; height:10px; line-height:10px; border-radius:5px; background:#b4ea74;" ref="idProgBar"></div>
						<div style="position:absolute; width:100%; height:10px; line-height:10px; color:#2a83cf; text-align:center; font-size:8px; font-style: italic;" ref="idProgCapt"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; margin-top:10px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:350px;  margin-top:-1px; margin-left:20px;">{{getLangText('收费标准')}}</div>

			<div style="float:left; border:0px solid red;" ref="idP1">
				<div style="float:left; margin-top:6px; padding-right:6px;">{{getLangText('一张:')}}</div>
				<input type="text" style="float:left; width:80px; height:30px;" maxlength="11" value="0" ref="idP1.price">
			</div>

			<div style="float:left; border:0px solid red; margin-left:20px;" ref="idP2">
				<div style="float:left; margin-top:6px; padding-right:6px;">{{getLangText('二张:')}}</div>
				<input type="text" style="float:left; width:80px; height:30px;" maxlength="11" value="0" ref="idP2.price">
			</div>

			<div style="float:left; border:0px solid red; margin-left:20px;" ref="idP3">
				<div style="float:left; margin-top:6px; padding-right:6px;">{{getLangText('三张:')}}</div>
				<input type="text" style="float:left; width:80px; height:30px;" maxlength="11" value="0" ref="idP3.price">
			</div>

			<div style="float:left; border:0px solid red; margin-left:20px;" ref="idP4">
				<div style="float:left; margin-top:6px; padding-right:6px;">{{getLangText('四张:')}}</div>
				<input type="text" style="float:left; width:80px; height:30px;" maxlength="11" value="0" ref="idP4.price">
			</div>

			<div style="float:left; border:0px solid red; margin-left:20px;" ref="idP5">
				<div style="float:left; margin-top:6px; padding-right:6px;">{{getLangText('五张:')}}</div>
				<input type="text" style="float:left; width:80px; height:30px;" maxlength="11" value="0" ref="idP5.price">
			</div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;" v-if="custAiFlag">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:350px;  margin-top:-1px; margin-left:20px;">{{getLangText('AI预警次数')+'(50-1000)'}}</div>
			<input type="text" style="width:100px;" maxlength="4" v-model="custAlarm" ref="idAlarm">
		</div>

		<div style="float:left; width:400px; height:40px; border:0px solid red; margin-top:20px;">
			<div class="NButton DIVNoSelect" style="width:120px; height:36px; float:left; margin-left:400px;" @click="onSaveClick">{{getLangText("保存")}}</div>
		</div>

	</div>
</template>

<script>

import radio      from '../cf/cradio'

export default {
	name: 'compInfo',
	components:{
		radio
	},
	data () {
		return {
			chkSourceFlag: 1,
			chkModelFlag: 1,
			custName: "",
			custEmail: "",
			custLocate: "",
			custId: "",
			prog: 0,
			FName: "",
			imgW: 0,
			imgH: 0,
			KeySourceFlag: 1000,
			KeyModelFlag: 2000,
			custAiFlag: this.login.custAiFlag,
			custAlarm: this.login.custAlarmTimes
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		this.getCustInfo();
	},
	computed:{

	},
	methods:{
		onAcctInfoClick: function(){
			this.$router.push( "/FrameBody/acctInfo" );
		},
		onAIInfoClick: function(){
			this.$router.push( "/FrameBody/aiInfo" );
		},
		getCustInfo: function(){
			let body={custId: this.login.custId };
			this.doTrade( "POST", ServAddr+"/api/cust/getCustInfo", this.getCustInfoOK, true, body, null );
		},
		getCustInfoOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.custName   = data.body.custName;
			this.custEmail  = data.body.custEmail;
			this.custLocate = data.body.custLocate;
			this.custId     = data.body.custId;
			this.chkSourceFlag = data.body.custSourceFlag;
			this.chkModelFlag  = data.body.custModelFlag;

			this.$refs["idSourceFlag"+this.chkSourceFlag].setChecked( true );
			this.$refs["idModelFlag"+this.chkModelFlag].setChecked( true );

			let prices=JSON.parse(data.body.custPrice);
			for( let i=0; i<prices.length; i++ )
			{
				this.$refs["idP"+(prices[i].n)+".price"].value = prices[i].p / 100;
			}

			if( data.body.cfImgPath )
			{
				let image = new Image();
			    let bytes=0;                     //图片的字节数
			    let that=this;
			    image.onload=function(){
			    	that.imgW=image.width;       //图片的原始宽度
			    	that.imgH=image.height;      //图片的原始高度
			    	let wh=that.getZoomSize(300, 200, that.imgW, that.imgH);     //计算缩放后的规格
			    	that.$refs["idImgPan"].style["width"]  = wh[0]+"px";    //置缩放后的宽度
			    	that.$refs["idImgPan"].style["height"] = wh[1]+"px";    //置缩放后的高度
			    	that.$refs["idImgPan"].src = image.src;
			    };

			    image.src = data.body.cfImgPath;
			}
		},
		/* 上传文件 */
		onUploadClick: function(){
			if( this.$refs["idImgFile"].files.length==0 )
			{
				this.onSaveDoing( { code:200 } );
			}
			else
			{
				this.prog = 0;
				this.$refs["idProgBar"].style["width"] = this.prog+"%";
				this.$refs["idProgCapt"].innerText = this.prog+"%";
				this.FName = this.$refs["idImgFile"].files[0].name;

				this.doUpload( ServAddr+"/api/pub/fileUpload", this.$refs["idImgFile"].files[0], true, this.onFileFinish, this.ProgressBar )
			}
		},
		onFileFinish: function( res ){
			this.appRoot.app.closeDlgRun();

			if( res.code == 200 )   // 上传成功
			{
				let body={ 	cfFileName: this.FName,
							cfCustId: this.login.custId,
							cfDeviceId: 0,
							cfImgType: 2,
							cfSize: this.imgW+","+this.imgH,
							cfImgPath:res.body.filePath };
				this.doTrade( "POST", ServAddr+"/api/custFile/custFileAdd", this.onSaveDoing, true, body, null );
			}
			else
			{
				this.appRoot.app.showDlgTip( 1200, LangText("上传失败"), this.CLR.Err );
			}
		},
		/* 保存 */
		onSaveClick: function(){
			this.onUploadClick();
		},
		onSaveDoing: function( res ){
			var FORMAT_MONEY  = /^\d+(\.\d{0,2})?$/;

			if( res.code == 200 )   // 上传成功
			{
				let price=[];
				for( let i=0; i<5; i++ )
				{
					// 检查价格是否数字
					let v=this.$refs["idP"+(i+1)+".price"].value;
					//console.log( v );
					if( !FORMAT_MONEY.test(v) )
					{
						this.appRoot.app.showDlgTip( 1200, LangText("错误的金额设置")+" "+v, this.CLR.Err );
						this.$refs["idP"+(i+1)+".price"].focus();
						return;
					}

					let pArr=v.split(".");
					let p = parseInt(pArr[0])*100;
					if( pArr.length==2 )
					{
						if( pArr[1].length==1 ) p = p + parseInt(pArr[1])*10;
						if( pArr[1].length==2 ) p = p + parseInt(pArr[1]);
					}
					//let p=parseInt("0"+v);
					if( 0 < p ) price.push( { n:(i+1), p:p} );
					//if( 0 < p ) price.push( { n:(i+1), p:p*100} );
				}

				let v=parseInt(this.custAlarm);
				if( v<50 )
				{
					this.appRoot.app.showDlgTip( 1200, LangText("预警次数不能小于 50"), this.CLR.Err );
					this.$refs["idAlarm"].focus();
					return;
				}
				if( 1000<v )
				{
					this.appRoot.app.showDlgTip( 1200, LangText("预警次数不能大于 1000"), this.CLR.Err );
					this.$refs["idAlarm"].focus();
					return;
				}
				this.custAlarm = v;

				let file=this.$refs["idImgFile"];
				let filePic = file.files[0];
				let body={  custId: parseInt(this.custId),
							custName: this.custName,
							custEmail: this.custEmail,
							custLocate: this.custLocate,
							custPrice: JSON.stringify(price),
							custSourceFlag: this.chkSourceFlag,
							custAlarmTimes: this.custAlarm,
							custModelFlag: this.chkModelFlag };

				this.doTrade( "POST", ServAddr+"/api/cust/custEdit", this.custEditOK, true, body, null );
			}
			else
			{
				this.appRoot.app.closeDlgRun();
			}
		},
		custEditOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
			}
		},

		onFileClick: function(){
			this.$refs["idImgFile"].files = null;
			this.$refs["idImgFile"].click();
		},
		onImgChange: function(){
			let file=this.$refs["idImgFile"];
			let image = new Image();
		    let bytes=0;                     //图片的字节数
		    let that=this;
		    image.onload=function(){
		    	that.imgW=image.width;       //图片的原始宽度
		    	that.imgH=image.height;      //图片的原始高度
		    	let wh=that.getZoomSize(300, 200, that.imgW, that.imgH);     //计算缩放后的规格
		    	that.$refs["idImgPan"].style["width"]  = wh[0]+"px";    //置缩放后的宽度
		    	that.$refs["idImgPan"].style["height"] = wh[1]+"px";    //置缩放后的高度
		    	that.$refs["idImgPan"].src = image.src;
		    };

			let filePic = file.files[0];
			if( !filePic ) return;

			bytes = filePic.size;
		    let reader = new FileReader();
		    reader.onload = function (e) {
		        let data = e.target.result;
		        image.src = data;
		    };
		    reader.readAsDataURL(filePic);
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// compInfo.vue?78258390